import {
  Box,
  ChakraStyleProps,
  Stack,
  StackProps,
  TextProps,
  useMediaQuery,
  Text,
} from "@chakra-ui/react";
import { AnimateSharedLayout, motion } from "framer-motion";
import React, { forwardRef, useState, FC } from "react";

const ButtonStyling: {
  root: Partial<
    ChakraStyleProps &
      Pick<StackProps, "direction" | "spacing" | "align" | "justify">
  >;
  text: Partial<TextProps>;
} = {
  root: {
    backgroundColor: "#D95D5D",
    borderRadius: "50px",
    boxShadow: "0px 5px 32px -7px rgba(126, 136, 151, 0.8)",
    direction: "row",
    padding: "12px 24px",
    position: "relative",
    cursor: "pointer",
    spacing: "4",
    align: "center",
    justify: "flex-start",
  },
  text: {
    color: "#fff",
    flexGrow: 1,
  },
};

type TargetProps = {
  onClick: () => void;
};

const MotionStack = motion(Stack);
export const CampaignFloater = forwardRef<HTMLDivElement, TargetProps>(
  (props, ref) => {
    const { onClick } = props;
    const [isLargerThan900] = useMediaQuery("(min-width: 900px)");
    const [text, setText] = useState("Gana €");
    return (
      <AnimateSharedLayout>
        <MotionStack
          id="subscribePlatformPopoverTrigger"
          ref={ref}
          {...ButtonStyling.root}
          onClick={onClick}
          onMouseEnter={() => setText("Crea un grupo y Gana 3 €")}
          onMouseLeave={() => setText("Gana €")}
          layout
          transition={{ duration: 0.25, type: "spring" }}
        >
          <Box width="10px !important">🎁</Box>
          <Text
            {...ButtonStyling.text}
            textStyle={isLargerThan900 ? "button" : "buttonMobile"}
          >
            {text}
          </Text>
        </MotionStack>
      </AnimateSharedLayout>
    );
  }
);

export const CampaignIcon: FC<TargetProps> = (props) => {
  const { onClick } = props;
  return (
    <Stack
      spacing="2"
      onClick={onClick}
      direction="row"
      align="center"
      style={{ cursor: "pointer" }}
    >
      <Text>🎁</Text>
      <Text textStyle="bodySmall">Gana €</Text>
    </Stack>
  );
};
